var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',_vm._l((_vm.options),function(option){return _c('p',{staticClass:"control"},[_c('b-tooltip',{attrs:{"label":option.label}},[_c('b-button',{class:{ 'is-active': _vm.value === option.value },attrs:{"icon-left":option.icon},on:{"click":function($event){_vm.value = option.value}}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }